import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import ActorAccessory from '../../../domain/entities/ActorAccessory';

export default function reducer(
  state: {[key: number]: ActorAccessory} = {},
  action: AnyAction,
): {[key: number]: ActorAccessory} {
  switch (action.type) {
    case Types.IndexActorAccessoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: ActorAccessory}, record: ActorAccessory) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    default:
      return state;
  }
}
